import {SimpleEntity} from "../simple-entity.model";
import {WhForwardingPackEditModel} from "./wh-forwarding-pack-edit.model";
import {StatusHistoryModel} from '../status-history.model';

export class WhForwardingModel {
  id: number;
  referenceNo: string;
  warehouse: SimpleEntity;
  branch: SimpleEntity;
  forwardingType: string;
  consignee: SimpleEntity;
  consigneeAddress: SimpleEntity;
  createdUser: SimpleEntity;
  description: string;
  receiver: string;
  receiverAddress: string;
  ownerType: string;
  products: WhForwardingPackEditModel[] = [];
  createDate: Date;
  orderDate: Date;
  statusType: string;
  statusHistoryDTOS: StatusHistoryModel[] = [];
}
